<template>
	<div>
		<transition name="fadeLeft">
			<div v-show="!instructionsVisible" class="hello hello-wrapper">
				<div class="panel gray-tilted-1">
					<div class="title">
						{{ simulado.SimuladoTituloInicial }}
					</div>
					<div class="info">
						<span class="label">Nome do inscrito</span>
						{{ simulado.NomeCompleto }}
					</div>
					<div class="info">
						<span class="label">CPF</span>
						<span class="cpf">{{ simulado.Cpf }}</span>
					</div>
					<div class="info">
						<span class="label">Data de nascimento</span>
						{{ simulado.DataNascimento }}
					</div>
					<div class="info">
						<span class="label">Email</span>
						{{ simulado.Email }}
					</div>
					<div class="info">
						<span class="label">Escola</span>
						{{ simulado.Escola }}
					</div>
				</div>
				<div class="panel white-tilted-1">
					<div class="instructions">
						<p>
							<strong class="name">Olá {{ simulado.PrimeiroNome }},</strong>
						</p>

            <div v-html="simulado.SimuladoTextoInicial"></div>
					</div>
					<button @click="showInstructions" class="btn btn-pink btn-lg">Next</button>
				</div>
			</div>
		</transition>
		<transition name="fadeLeft">
			<instructions :simulado="simulado" v-show="instructionsVisible"></instructions>
		</transition>
	</div>
</template>

<style scoped lang="scss">
	.hello {


		.white-tilted-1 {
			margin: 0 auto;

			.instructions {
				padding-top: 90px;
				padding-left: 330px;
				padding-right: 120px;
				font-size: 17px;

				strong.name {
					display: block;
					font-size: 24px;
				}
			}
		}
		.gray-tilted-1 {
			position: absolute;
			top: 25px;
		}

		.btn {
			position: absolute;
			right: 121px;
			bottom: 55px;
		}
	}
</style>

<script>
	import instructions from './Instructions.vue'

	export default {
		props: ['simulado'],
		mounted() {
			$(this.$el).find(".cpf").mask('000.000.000-00');
		},
		data() {
			return {
				instructionsVisible: false
			}
		},
		methods: {
			showInstructions() {
				this.instructionsVisible = true
			}
		},
		computed: {
			textoDuracao() {
				var horas = Math.ceil(this.simulado.SimuladoTempoTotal / 60);

				if(horas == 1) return horas + " hora"

				return horas + " horas"
			}
		},
		components: {
			'instructions': instructions
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/start/Hello.vue